<template>
  <el-dialog
    :title="$t('upgrade_page_views_diamond_recharge_diamond_dialog_419')"
    :visible.sync="visible"
    width="400px"
    append-to-body
    center
    destroy-on-close
  >
    <div class="diamond-pay">
      <div class="diamond-transition">{{$t('upgrade_page_views_diamond_recharge_diamond_dialog_420')}}</div>
      <div class="diamond-pay-box">
        <el-input
          v-model.number="inputNicee"
          type="text"
          maxlength="10"
          clearable
        >
          <img slot="prefix" src="~@/assets/image/icons/coin.png" />
        </el-input>
        <div class="diamond-number">
          <img src="~@/assets/image/icons/diamond.png" />
          <span>{{ inputDiamond }}</span>
        </div>
        <!-- <el-input
          v-model="inputDiamond"
          type="number"
          maxlength="12"
          :disabled="true"
        >
          <img slot="prefix" src="~@/assets/image/icons/diamond.png" />
        </el-input> -->
      </div>
      <!-- <div class="pay-num">
        <span>您要支付</span><span class="pay-num-item">{{ inputNicee }}</span
        ><img src="~@/assets/image/icons/coin.png" alt="" />
      </div> -->
      <div>
        <el-button>{{$t('upgrade_page_layout_header_42')}}</el-button>
        <el-button
          @click="onClickPay"
          :disabled="!inputNicee || payLoading"
          :loading="payLoading"
          >{{$t('upgrade_page_views_diamond_recharge_diamond_dialog_421')}}</el-button
        >
      </div>
    </div>
  </el-dialog>
</template>
<script>
import i18n from '../../../locales/index'

export default {
  name: 'UserRelation',
  props: {
    accountInfo: {
      type: Object,
      default: () => {}
    },
    userInfo: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      visible: false,
      inputNicee: 0,
      payLoading: false
    };
  },
  watch: {},
  computed: {
    inputDiamond() {
      return this.accountInfo.convertRatio
        ? this.inputNicee * this.accountInfo.convertRatio
        : 0;
    }
  },
  methods: {
    //鑽石購買點擊確認支付
    onClickPay() {
      if (this.payLoading) return;
      if (!(this.userInfo && this.userInfo.uuid)) {
        this.$util.Login();
      } else if (this.inputNicee <= this.accountInfo.balance) {
        this.payLoading = true;
        this.$http
          .post('/account/convertAccount', {
            accountKind: 'Balance',
            convertAccountKind: 'Diamond',
            convertAmount: this.inputNicee,
            userUuid: this.userInfo.uuid
          })
          .then(() => {
            this.$store.dispatch('app/getUserAccount');
            this.inputNicee = 0;
            this.visible = false;
            this.payLoading = false;
          });
      } else {
        this.$confirm({
          content: i18n.t('upgrade_page_views_diamond_recharge_diamond_dialog_422', [this.accountInfo.balance]),
          confirmButtonText: i18n.t('upgrade_page_views_diamond_recharge_diamond_dialog_423'),
          cancelButtonText: i18n.t('upgrade_page_layout_header_42'),
          closeOnClickModal: false,
          dangerouslyUseHTMLString: true
        }).finally(() => {
          this.visible = false;
          this.payLoading = false;
        });
      }
    },
    //鑽石支付彈窗
    showPayDialog() {
      this.inputNicee = 0;
      this.visible = true;
      this.payLoading = false;
    }
  }
};
</script>
<style lang="scss" scoped>
//鑽石購買彈窗
/deep/ .el-dialog {
  border-radius: 20px;
  .el-dialog__body {
    padding-top: 0;
  }
  .el-input.is-disabled .el-input__inner {
    background: #fff;
    color: #222c43;
    font-size: 20px;
    font-weight: 700;
  }
  .el-input__inner {
    border: none;
    border-radius: 80px;
    background-color: #e7e9ee;
    padding-left: 40px;
    margin: 0;
  }
  .el-button {
    border-radius: 100px;
    width: 120px;
    background-color: #e7e9ee;
    border: none;
    &:hover {
      color: #606266;
    }
  }
  .el-button + .el-button {
    background-color: #ffeb36;
  }
  .diamond-pay {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .diamond-transition {
      display: flex;
      align-items: center;
      margin: 10px 0;
      > span {
        display: flex;
        align-items: center;
      }
    }
    .diamond-pay-box {
      margin-top: 10px;
      display: flex;
      align-items: center;
    }
    .pay-num {
      margin: 10px 0;
      display: flex;
      align-items: center;
      .pay-num-item {
        font-size: 20px;
        font-weight: 600px;
        color: #f56c6c;
        padding-bottom: 2px;
      }
    }
    img {
      width: 24px;
      height: 24px;
    }
    .diamond-pay-box {
      margin-bottom: 20px;
      .el-input {
        width: 150px;
        .el-input__prefix {
          top: 8px;
        }
      }
      .diamond-number {
        display: flex;
        align-items: center;
        img {
          margin: 0 4px;
        }
      }
    }
  }
}
</style>
